<div class="rangebox-container">
    <label for="rangebox" style="font-weight:normal;" [hidden]="!label">{{label}}</label>
    <input type="range" [min]="min" [max]="max" value="0" [(ngModel)]="value" id="rangebox" name="rangebox"/>
</div>